import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            alignContent: 'flex-start',
            flexWrap: 'wrap',
            gap: remCalc(40),
            alignSelf: 'stretch',
        },
        container: {
            display: 'flex',
            flexDirection: ['column', 'column', 'column', 'row'],
            alignItems: ['flex-start', 'flex-start', 'flex-start', 'center'],
            gap: [remCalc(60), remCalc(60), remCalc(60), 'unset'],
            width: '100%',
            justifyContent: 'space-between',
            alignSelf: ['unset', 'unset', 'unset', 'stretch'],
        },
        registeredText: {
            alignSelf: 'stretch',
            textAlign: 'center',
            textStyle: 'head-small',
            fontWeight: '500',
            color: 'text.default',
        },
        noPasswordText: {
            alignSelf: 'stretch',
            textAlign: 'center',
            textStyle: 'body-large',
            fontWeight: '400',
            color: 'text.default',
        },
        socialText: {
            alignSelf: 'stretch',
            textAlign: 'center',
            textStyle: 'body-large',
            fontWeight: '400',
            color: 'text.default',
        },
        horizontalDivider: {
            color: 'border.light',
            display: 'block',
        },
        verticalDivider: {
            display: 'flex',
            height: remCalc(434),
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(10),
        },
        button: {
            display: 'flex',
            height: remCalc(40),
            minWidth: remCalc(140),
            width: remCalc(332),
            maxHeight: remCalc(40),
            padding: `${remCalc(18)} ${remCalc(24)}`,
            justifyContent: 'center',
            alignItems: 'center',
            borderRadius: remCalc(100),
            border: null,
            borderColor: 'dark',
            borderStyle: 'solid',
            background: 'button.background.primary-default',
        },
        buttonText: {
            textStyle: 'body-medium',
            fontWeight: '700',
            color: 'button.text.primary-default',
        },
        loginLink: {
            textDecoration: 'underline',
            color: 'text.tertiary',
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
        },
        accountDetails: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
        },
        logoutContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: remCalc(32),
            alignSelf: 'stretch',
        },
        logoutText: {
            alignSelf: 'stretch',
            textAlign: 'center',
            textStyle: 'body-medium',
            fontWeight: '400',
            color: 'text.default',
        },
        guestContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
            alignSelf: 'stretch',
            maxWidth: remCalc(451),
        },
        guestTitle: {
            alignSelf: 'stretch',
            textStyle: 'head-small',
            fontWeight: '500',
            color: 'text.default',
        },
        guestDescription: {
            alignSelf: 'stretch',
            textStyle: 'body-medium',
            fontWeight: '400',
            color: 'text.default',
        },
        hideOnDesktop: {
            display: ['block', 'block', 'block', 'none'],
        },
        hideOnMobile: {
            display: ['none', 'none', 'none', 'flex'],
        },
    },
    variants: {
        account: {
            outerContainer: {
                display: 'flex',
                flexDirection: 'column',
                gap: remCalc(40),
                alignSelf: 'stretch',
                alignItems: 'flex-start',
                flexShrink: 0,
                alignContent: 'inherit', //check
                flexWrap: 'inherit', //check
            },
            container: {
                flexDirection: 'column',
                gap: remCalc(40),
                justifyContent: 'unset', //check
            },
            logoutContainer: {
                alignItems: 'flex-start',
            },
            logoutText: {
                textAlign: 'flex-start',
            },
            horizontalDivider: {
                maxWidth: remCalc(700),
            },
        },
    },
}
